













































import Vue from 'vue'
import _ from 'lodash'
import { FETCH_MASTER_DATA_WORK_LIST } from '@/store/action-types'
import { FreeShiftWork } from '@/model/master-data/FreeShiftWork'
import { GetArbeitenResponse } from '@/types/service-response'
import { UiLanguageItem } from '@/types'
import { Work } from '@/model/master-data/Work'

interface ComponentData {
  workList: Work[]
  workValidationRules: Array<Function>
  offsetValidationRules: Array<Function>
  formData: FreeShiftWork | undefined
}

export default Vue.extend({
  name: 'FreeShiftOffsetEditorDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    dialogData: {
      type: Object as () => FreeShiftWork
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      workList: [],
      workValidationRules: [
        required
      ],
      offsetValidationRules: [
        required
      ],
      formData: undefined
    }
  },

  computed: {
    selectedUiLanguage (): UiLanguageItem {
      return this.$store.state.selectedUiLanguage
    },
  },

  watch: {
    dialogData (newVal: boolean): void {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      if (newVal) {
        this.formData = _.cloneDeep(this.dialogData)
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    }
  },

  methods: {
    getWorkLabel (item: Work): string {
      //const foundText: WorkDescription | undefined = item.descriptionList.find((item: WorkDescription) => item.language === this.selectedUiLanguage.syzId)
      return `${item.code} - ${item.getDescriptionLabel}`
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.formData) {
          const workItem: Work | undefined = _.find(this.workList, { id: this.formData.work })
          if (workItem && this.formData) {
            //const foundText: WorkDescription | undefined = workItem.descriptionList.find((item: WorkDescription) => item.language === this.selectedUiLanguage.syzId)
            this.formData.workCode = workItem.getDescriptionLabel
            this.formData.workItem = workItem
          }
        }
        this.$emit('createNewOffset', this.formData)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    async fetchWorkList (): Promise<void> {
      try {
        const response: GetArbeitenResponse = await this.$store.dispatch(FETCH_MASTER_DATA_WORK_LIST)
        if(response && !response.IsError) {
          this.workList = Work.createListFromResponse(response.Arbeiten)
        } else {}
      } catch (e) {}
    }
  },

  created () {
    this.formData = new FreeShiftWork(
      undefined,
      undefined,
      undefined,
      0,
      '',
      undefined,
      '',
      '00:00',
      undefined
    )

  },

  mounted (): void {
    this.fetchWorkList()
    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
